module.exports = __webpack_public_path__ + "static/Group-1-434d1842abdda0d838fe4c00ada9f55d.png";